






















import {
  defineComponent,
  ref,
  inject,
  computed,
  onMounted
} from '@vue/composition-api'
import ApiLoader from '@/contexts/frontend/ApiLoader.vue'
import Restricted from '@/contexts/auth/Restricted.vue'
import { Auth } from 'aws-amplify'
import { ClientAdminApiKey } from '@/rest/client-admin-api'
import { useClientIdState } from './clients.state'
import { noticeablyAsync } from '@/lib/async'
import router from '@/router'

export default defineComponent({
  components: {
    Restricted,
    ApiLoader
  },

  setup() {
    const clients = ref([])
    const loading = ref(null)

    const clientAdminApi = inject(ClientAdminApiKey)
    const clientIdState = useClientIdState()

    onMounted(() => {
      const noticeablyListClients = noticeablyAsync(() =>
        clientAdminApi.ListClients().then(result => (clients.value = result))
      )
      loading.value = noticeablyListClients()
    })

    const clientsFound = computed(() => clients.value.length > 0)

    const onClientChanged = () => {
      Auth.currentAuthenticatedUser()
        .then(user =>
          Auth.updateUserAttributes(user, {
            'custom:client': clientIdState.clientId
          })
        )
        .then(() => router.push({ name: 'conversations' }))
        .then(() => window.location.reload())
    }

    const clientsSorted = computed(() => {
      return clients.value.sort((a, b) => (a.name > b.name ? 1 : -1))
    })

    return {
      clientIdState,
      clients,
      loading,
      clientsFound,
      onClientChanged,
      clientsSorted
    }
  }
})
